
import {
    type PropType,
    computed,
    defineComponent,
} from 'vue';
import {
    type MonacoDiffEditorOpts,
    useMonacoDiffEditor,
} from 'src/util/composables/use-monaco-editor';

export const MonacoDiff = defineComponent({
    name: 'MonacoDiff',
    props: {
        language: {
            required: true,
            type: String as PropType<MonacoDiffEditorOpts['language']>,
        },
        before: {
            type: String,
            required: true,
        },
        after: {
            type: String,
            required: true,
        },
    },
    setup (props) {
        const {
            editorAnchor,
        } = useMonacoDiffEditor({
            language: props.language,
            after: computed(() => props.after),
            before: computed(() => props.before),
        });

        return {
            editorAnchor,
        };
    },
});
export default MonacoDiff;

